/* eslint-disable @typescript-eslint/dot-notation */
import React, { FC, PropsWithChildren } from 'react'
import SideMenu from '../SideMenu'
import styles from './index.module.less'
import ContactFloat from '../ContactFloat/ContactFloat'

const AppLayout:FC<PropsWithChildren> = (props) => (
  <div className={styles['layout']}>
    <SideMenu />
    <div style={{ height: '100%', overflow: 'auto', padding: '16px', color: '#1f1f1f', flex: 1, background: '#f5f5f5' }}  className={styles['content-wraper']}>
      {props.children}
    </div>
    <ContactFloat />
  </div>
)
export default AppLayout